<template>
	<b-modal
		ref="edit-qualify-modal"
		:title="`Editar Calificación de ${specimen.alias ? specimen.alias : '---'} (${specimen.plate}) | ${
			item.user_name
		}`"
		no-close-on-backdrop
		centered
		@hidden="handleHidden"
		width="500px"
		:ok-title="'Guardar'"
		:ok-disabled="currentUser.id != item.user"
		@ok.prevent="updateQualify"
	>
		<div class="d-flex flex-column m-2">
			<b-row class="d-flex w-full mb-2">
				<b-col cols="8" class="pl-2">
					<veeno
						pipsy
						:connect="[true, false]"
						:handles="[initialRating]"
						:range="{ min: 0, max: 5 }"
						:step="0.1"
						v-model="specimenScore"
						:disabled="currentUser.id != item.user"
					/>
				</b-col>
				<b-col class="text-center text-nowrap text-weight-bolder h4">{{ specimenScore }} / 5</b-col>
			</b-row>
			<div class="font-weight-bolder my-2">Caracteristicas:</div>
			<div v-if="currentUser.id == item.user">
				<v-select
					multiple
					label="name"
					:options="characteristicsOptions"
					:clearable="false"
					:searchable="false"
					:reduce="(option) => option.id"
					v-model="characteristics"
					:disabled="currentUser.id != item.user"
				>
					<template v-slot:option="option">
						<span>
							{{ option.name }}
						</span>
					</template>
				</v-select>
			</div>
			<div v-else>
				<b-badge
					v-for="(characteristic, index) in characteristics"
					class="mr-1"
					:key="`characteristic-${index}`"
					variant="secondary"
				>
					{{ characteristicsOptions.find((item) => item.id == characteristic).name }}
				</b-badge>
			</div>
			<div class="font-weight-bolder my-2">Cualidades:</div>
			<div v-if="currentUser.id == item.user">
				<v-select
					multiple
					label="name"
					:options="qualitiesOptions"
					:clearable="false"
					:searchable="false"
					:reduce="(option) => option.id"
					v-model="qualities"
				>
					<template v-slot:option="option">
						<span>
							{{ option.name }}
						</span>
					</template>
				</v-select>
			</div>
			<div v-else>
				<b-badge
					v-for="(quality, index) in qualities"
					class="mr-1"
					:key="`quality-${index}`"
					variant="secondary"
				>
					{{ qualitiesOptions.find((item) => item.id == quality).name }}
				</b-badge>
			</div>
		</div>
	</b-modal>
</template>

<script>
import preparacionService from "@/services/preparacion/default.service.js"
import veeno from "veeno"
import qualitiesService from "@/views/brain/specimens/views/qualities/services/qualities.services.js"
export default {
	components: {
		veeno,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
		specimen: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			specimenScore: 0,
			initialRating: 0,
			characteristics: [],
			qualities: [],
			qualitiesOptions: [],
			characteristicsOptions: [],
		}
	},
	computed: {},
	methods: {
		async getQualities() {
			this.isPreloading()
			try {
				const { data } = await qualitiesService.getQualities({
					is_active: 1,
					specimen_category_id: 3,
				})
				this.qualitiesOptions = data.data.filter((item) => item.type == "quality")
				this.characteristicsOptions = data.data.filter((item) => item.type == "characteristic")
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		handleHidden() {
			this.$emit("close")
		},
		async updateQualify() {
			try {
				this.isPreloading()
				await preparacionService.updateQualify({
					specimen_id: this.specimen.id,
					confrontation_score_id: this.item.confrontation_score_id,
					score: this.specimenScore,
					qualities: this.qualities,
					characteristics: this.characteristics,
					confrontation_id: this.specimen.confrontation_id,
				})
				this.$emit("refresh")
				this.showToast("success", "top-right", "Felicidades", "CheckIcon", "Calificación actualizada")
				this.$emit("close")
			} catch (error) {
				console.log(error)
				this.showToast("danger", "top-right", "Pollos", "InfoIcon", "Error al actualizar la calificación")
			}
		},
	},
	async mounted() {
		await this.getQualities()
		this.initialRating = this.item.score
		this.qualities = [...this.specimen.qualities]
		this.characteristics = [...this.specimen.characteristics]
		this.$refs["edit-qualify-modal"].toggle()
	},
}
</script>

<style scoped lang="scss"></style>
